import { render } from "./dotsloader.vue?vue&type=template&id=274f3461"
const script = {}

import "./dotsloader.vue?vue&type=style&index=0&id=274f3461&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__